import BaseEvent from "../../util/baseEvent"
import { DISCOVER, ERRORLIST, ITC, TIMEROUT } from "../../util/eventTypes"
import httpService from "./httpService"
import axios from "axios"
// 最大存储P数量 5
const MAX_STORE_IDC_LIST = TIMEROUT.MAX_STORE_IDC_LIST
// 每个EP重连次数 3
const MAX_RETRY_TIMES = TIMEROUT.MAX_RETRY_TIMES
// 每个Idc最大Ping 5
const MAX_PING_TIMES = TIMEROUT.MAX_PING_TIMES
// 每个Idc最大Ping 5
const RECONNECT_MAX_DISCOVER_TIMES = TIMEROUT.RECONNECT_MAX_DISCOVER_TIMES
class Discover extends BaseEvent {
  constructor(options) {
    super()
    this.$logger.setPrefix("discover")
    this.options = options
    this.storeIdcList = [] // 存储可用的Idc
    this.enableIdc = "" // ping5次成功后的可用的Idc
    // 默认单个EP的最大直接连接次数是3次
    this.singleIdcConnectTime = MAX_RETRY_TIMES
    // 当前正在执行Ping操作的EP请求列表
    this.pingXhrList = {}
    // 重连次数
    this.discoverFailCount = 0
    // 全部Ping是否结束
    this.pingFinished = true
    this.pingFinishCount = 0
    this.initEvent()
  }
  initEvent() {
    // 重连成功以后 重置当前discover次数和当前EPretry次数
    this.eventEmitter.on(ITC.CONNECTED, () => {
      this.discoverFailCount = 0
      this.singleIdcConnectTime = MAX_RETRY_TIMES
    })
  }
  // 开始选点
  start(idcList) {
    this.idcList = idcList
    if (!this.idcList || !this.idcList.length) {
      return
    }
    // 开始连接
    this.eventEmitter.emit(ITC.START_CONNECT)
    this.once("GET_NODE_SUCCESS", (currentEp, options) => {
      this.eventEmitter.emit(ITC.PING_SUCCESS, currentEp, options)
      this.removeAllListeners("GET_NODE_FAILED")
    })
    this.once("GET_NODE_FAILED", () => {
      this.removeAllListeners("GET_NODE_SUCCESS")
      this.eventEmitter.emit(ITC.ERROR, ERRORLIST.ALL_EP_TIMEOUT)
    })
    // 开始获取idc
    this.getIdc()
  }
  getIdc() {
    // 如果有可用IDC 直接消耗可用IDC
    if (this.enableIdc) {
      this.consumeStoreIdc()
      return
    }
    // 如果全部Ping的没有完成 只需要等待下一次ping成功 或者所有的Ping失败
    if (!this.pingFinished) {
      return
    }
    // 如果ping执行次数超过2次 抛出异常
    if (this.discoverFailCount >= RECONNECT_MAX_DISCOVER_TIMES) {
      this.eventEmitter.emit(ITC.CLOSE, ERRORLIST.ABOVE_MAX_DISCOVER_TIMES)
      return
    }
    this.pingFinished = false
    this.discoverFailCount += 1
    this.getAllEnableIdcByPing(this.idcList)
  }
  /**
   * 使用完成Ping的Idc
   * 每调用一次 singleIdcConnectTime-1
   * 当singleIdcConnectTime<=0:
   * 如果有存储 取新值 同时重置singleIdcConnectTime
   * 如果没有 enableIdc=''
   * 默认单个EP的最大直接连接次数是3次
   **/
  consumeStoreIdc() {
    this.emit("GET_NODE_SUCCESS", this.enableIdc, {
      type: "store"
    })
    // 可用重试次数-1
    this.singleIdcConnectTime -= 1
    if (this.singleIdcConnectTime > 0) {
      return
    }
    if (!this.storeIdcList.length) {
      this.enableIdc = ""
    } else {
      this.enableIdc = this.storeIdcList.shift()
      this.singleIdcConnectTime = MAX_RETRY_TIMES
    }
  }
  shiftIdc() {
    this.error("shiftIdc in discover.ts not implemented!")
  }
  /**
  从EP列表中获取可用的EP列表
  EP列表中的每个EP自动执行重连
  **/
  getAllEnableIdcByPing(list) {
    this.pingPromiseList = []
    list.forEach((idcName, index) => {
      this.pingPromiseList.push(this.doPing(idcName))
    })
    Promise.all(this.pingPromiseList)
      .then(() => {
        this.pingFinished = true
      })
      .catch(args => {
        this.pingFinished = true
        if (!this.storeIdcList.length) {
          this.emit("GET_NODE_FAILED")
        }
      })
  }
  /**
  每个EP执行Ping操作
  **/
  doPing(idcName) {
    return new Promise((resolve, reject) => {
      // 成功处理
      let successCallback = config => {
        this.reportQualityNode(idcName)
        // 记录请求成功
        // this.eventEmitter.emit(LOG.INFO, DISCOVER.PING_SUCCESS, {
        //   idcName,
        //   ranges: config.totalRanges.join(","),
        //   total: config.totalRanges.reduce((sum, n) => {
        //     return sum + n
        //   })
        // })
        this.$logger.info(DISCOVER.PING_SUCCESS, {
          idcName,
          ranges: config.totalRanges.join(","),
          total: config.totalRanges.reduce((sum, n) => {
            return sum + n
          })
        })
        resolve({
          totalRanges: config.totalRanges,
          idcName,
          code: "success"
        })
      }
      // 失败处理
      let errorCallback = config => {
        reject(
          new Error(
            `[pingFail].message:${config.message}.idc:${config.idcName}`
          )
        )
      }
      // 开始执行Ping
      this.ping({
        idcName,
        count: 0,
        exceptionalCount: 0,
        totalRanges: [],
        successCallback,
        errorCallback
      })
    })
  }
  // Ping流程
  ping(config) {
    if (config.count >= MAX_PING_TIMES) {
      config.successCallback({
        status: 0,
        totalRanges: config.totalRanges,
        idcName: config.idcName
      })
      return
    }
    // 如果整体的选点操作已经结束了 就不再执行下一次Ping操作了
    if (this.pingFinished) {
      return
    }
    let startTime = new Date().getTime()
    let randomId = `${Math.random()}`.replace(".", "")
    // 创建一个请求取消的token
    let CancelToken = axios.CancelToken
    let source = CancelToken.source()
    httpService
      .ping(config.idcName, source.token, {
        count: config.count,
        randomId,
        role: this.options.role,
        userid: this.options.userid,
        roomid: this.options.roomid
      })
      .then(() => {
        let endTime = new Date().getTime()
        let range = endTime - startTime
        config.totalRanges.push(range)
        config.count += 1
        this.ping({
          idcName: config.idcName,
          count: config.count,
          exceptionalCount: config.exceptionalCount,
          totalRanges: config.totalRanges,
          successCallback: config.successCallback,
          errorCallback: config.errorCallback
        })
      })
      .catch(thrown => {
        // 判断这个请求是不是被用户中止的
        if (axios.isCancel(thrown) && thrown.message === "CANCELED_BY_USER") {
          config.errorCallback({
            status: -1,
            message: thrown.message,
            idcName: config.idcName
          })
          return
        }
        config.exceptionalCount += 1
        config.count += 1
        // 记录请求失败Log
        // this.eventEmitter.emit(LOG.WARNING, DISCOVER.PING_FAIL, {
        //   idcName: config.idcName,
        //   message: thrown.message,
        //   randomId,
        //   count: config.count,
        //   exceptionalCount: config.exceptionalCount
        // })
        this.$logger.warn(DISCOVER.PING_FAIL, {
          idcName: config.idcName,
          message: thrown.message,
          randomId,
          count: config.count,
          exceptionalCount: config.exceptionalCount
        })
        config.totalRanges.push(2000)
        // 如果一次失败不做处理 continue
        // 如果是第二次认为这个EP连接有问题 不可用
        if (config.exceptionalCount <= 1) {
          this.ping({
            idcName: config.idcName,
            count: config.count,
            exceptionalCount: config.exceptionalCount,
            totalRanges: config.totalRanges,
            successCallback: config.successCallback,
            errorCallback: config.errorCallback
          })
        } else {
          config.errorCallback({
            status: -1,
            idcName: config.idcName,
            message: "failed"
          })
        }
      })
    // 将请求句柄存储到列表中 方便整体请求完成以后将个别没完成的EP强制取消
    this.pingXhrList[config.idcName] = source
  }
  // 上报可用EP
  reportQualityNode(idcName) {
    // Ping完成次数
    this.pingFinishCount += 1
    // 如果存储的EP列表已经打到了最大的要求 结束选点
    if (this.pingFinishCount >= MAX_STORE_IDC_LIST) {
      this.pingFinishCount = 0
      this.abortXhr()
      return
    }
    if (!this.enableIdc || !this.enableIdc.length) {
      this.enableIdc = idcName
      this.singleIdcConnectTime = MAX_RETRY_TIMES
    } else {
      this.storeIdcList.push(idcName)
    }
    this.emit("GET_NODE_SUCCESS", idcName, {
      type: "discover"
    })
  }
  // 取消所有的请求
  abortXhr() {
    for (let i in this.pingXhrList) {
      if (this.pingXhrList.hasOwnProperty(i)) {
        this.pingXhrList[i]["cancel"]("CANCELED_BY_USER")
      }
    }
    this.pingXhrList = []
  }
  destroy() {
    this.removeAllListeners("GET_NODE_FAILED")
    this.removeAllListeners("GET_NODE_SUCCESS")
    this.abortXhr()
    this.discoverFailCount = 0
    this.pingFinishCount = 0
    this.pingFinished = true
  }
}
export default Discover
